import { render } from "./BillingOverview.vue?vue&type=template&id=8e28db06&scoped=true"
import script from "./BillingOverview.vue?vue&type=script&lang=js"
export * from "./BillingOverview.vue?vue&type=script&lang=js"

import "./BillingOverview.vue?vue&type=style&index=0&id=8e28db06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e28db06"]])

export default __exports__